import { render, staticRenderFns } from "./get-review.vue?vue&type=template&id=d1a78238&scoped=true&"
import script from "./get-review.vue?vue&type=script&lang=js&"
export * from "./get-review.vue?vue&type=script&lang=js&"
import style0 from "./get-review.vue?vue&type=style&index=0&id=d1a78238&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a78238",
  null
  
)

export default component.exports